import { createFileRoute, redirect } from "@tanstack/react-router";

/** Old Contacts page → People, "Everyone" view (bookmarks, notifications and emails keep working; `?peek=` is kept). */
export const Route = createFileRoute("/_app/contacts/")({
  beforeLoad: ({ search }) => {
    const peek = (search as Record<string, unknown>).peek;
    throw redirect({ to: "/people", search: { view: "everyone", ...(typeof peek === "string" ? { peek } : {}) } as never, replace: true });
  },
});
